// removed by extract-text-webpack-plugin
module.exports = {"item":"MobileNavDrilldownList__item__4630a8ee","count":"MobileNavDrilldownList__count__4630a8ee"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/MobileNavDrilldown/MobileNavDrilldownList.scss
// module id = ./src/components/MobileNav/MobileNavDrilldown/MobileNavDrilldownList.scss
// module chunks = 4